var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "subTab": "",
      "sh": "Project / Reference",
      "index": "02",
      "total": "02",
      "tabActive": "Reference",
      "bg": "/images/sub/visual/sv3.jpg"
    }
  }), _c('section', {
    staticClass: "section section--first section--last"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--lg dot-tit"
  }, [_vm._v("Global Reference")])]), _c('div', {
    staticClass: "reference-tab mb-30 mb-md-40 mb-lg-70"
  }, [_c('ul', [_c('li', [_c('button', {
    staticClass: "reference-tab__btn",
    class: {
      active: _vm.americaMenu
    },
    on: {
      "mouseenter": function mouseenter($event) {
        _vm.americaMenu = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.americaMenu = false;
      }
    }
  }, [_c('span', {
    staticClass: "reference-tab__dot"
  }), _c('span', {
    staticClass: "reference-tab__txt"
  }, [_vm._v("아메리카")])])]), _c('li', [_c('button', {
    staticClass: "reference-tab__btn",
    class: {
      active: _vm.middleEastMenu
    },
    on: {
      "mouseenter": function mouseenter($event) {
        _vm.middleEastMenu = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.middleEastMenu = false;
      }
    }
  }, [_c('span', {
    staticClass: "reference-tab__dot"
  }), _c('span', {
    staticClass: "reference-tab__txt"
  }, [_vm._v("중앙아시아")])])]), _c('li', [_c('button', {
    staticClass: "reference-tab__btn",
    class: {
      active: _vm.cisNationsMenu
    },
    on: {
      "mouseenter": function mouseenter($event) {
        _vm.cisNationsMenu = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.cisNationsMenu = false;
      }
    }
  }, [_c('span', {
    staticClass: "reference-tab__dot"
  }), _c('span', {
    staticClass: "reference-tab__txt"
  }, [_vm._v("독립국가연합")])])]), _c('li', [_c('button', {
    staticClass: "reference-tab__btn",
    class: {
      active: _vm.koreaMenu
    },
    on: {
      "mouseenter": function mouseenter($event) {
        _vm.koreaMenu = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.koreaMenu = false;
      }
    }
  }, [_c('span', {
    staticClass: "reference-tab__dot"
  }), _c('span', {
    staticClass: "reference-tab__txt"
  }, [_vm._v("대한민국")])])]), _c('li', [_c('button', {
    staticClass: "reference-tab__btn",
    class: {
      active: _vm.asiaMenu
    },
    on: {
      "mouseenter": function mouseenter($event) {
        _vm.asiaMenu = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.asiaMenu = false;
      }
    }
  }, [_c('span', {
    staticClass: "reference-tab__dot"
  }), _c('span', {
    staticClass: "reference-tab__txt"
  }, [_vm._v("아시아")])])])])]), _c('div', {
    staticClass: "map"
  }, [_c('div', {
    staticClass: "map__img"
  }, [_c('img', {
    attrs: {
      "src": "/images/sub/reference/map.png",
      "alt": "이미지"
    }
  })]), _c('v-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$vuetify.breakpoint.lgAndUp,
      expression: "$vuetify.breakpoint.lgAndUp"
    }],
    attrs: {
      "top": "",
      "offset-y": "",
      "content-class": "map__menu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('button', _vm._g(_vm._b({
          staticClass: "map__btn map__america",
          on: {
            "click": function click($event) {
              _vm.americaDialog = true;
            },
            "mouseenter": function mouseenter($event) {
              _vm.americaMenu = true;
            },
            "mouseleave": function mouseleave($event) {
              _vm.americaMenu = false;
            }
          }
        }, 'button', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.americaMenu,
      callback: function callback($$v) {
        _vm.americaMenu = $$v;
      },
      expression: "americaMenu"
    }
  }, [_c('div', {
    staticClass: "map__menu-inner",
    on: {
      "click": function click($event) {
        _vm.americaDialog = true;
      }
    }
  }, [_vm._v("아메리카")])]), _c('button', {
    staticClass: "map__btn map__america d-lg-none",
    on: {
      "click": function click($event) {
        _vm.referenceCon();

        _vm.americaCon = true;
      }
    }
  }), _c('u-dialog', {
    on: {
      "close": function close($event) {
        _vm.americaDialog = false;
      }
    },
    model: {
      value: _vm.americaDialog,
      callback: function callback($$v) {
        _vm.americaDialog = $$v;
      },
      expression: "americaDialog"
    }
  }, [_c('America')], 1), _c('v-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$vuetify.breakpoint.lgAndUp,
      expression: "$vuetify.breakpoint.lgAndUp"
    }],
    attrs: {
      "top": "",
      "offset-y": "",
      "content-class": "map__menu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on,
            attrs = _ref2.attrs;
        return [_c('button', _vm._g(_vm._b({
          staticClass: "map__btn map__middle-east",
          on: {
            "click": function click($event) {
              _vm.middleEastDialog = true;
            },
            "mouseenter": function mouseenter($event) {
              _vm.middleEastMenu = true;
            },
            "mouseleave": function mouseleave($event) {
              _vm.middleEastMenu = false;
            }
          }
        }, 'button', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.middleEastMenu,
      callback: function callback($$v) {
        _vm.middleEastMenu = $$v;
      },
      expression: "middleEastMenu"
    }
  }, [_c('div', {
    staticClass: "map__menu-inner",
    on: {
      "click": function click($event) {
        _vm.middleEastDialog = true;
      }
    }
  }, [_vm._v(" 중앙아시아 ")])]), _c('button', {
    staticClass: "map__btn map__middle-east d-lg-none",
    on: {
      "click": function click($event) {
        _vm.referenceCon();

        _vm.middleEastCon = true;
      }
    }
  }), _c('u-dialog', {
    on: {
      "close": function close($event) {
        _vm.middleEastDialog = false;
      }
    },
    model: {
      value: _vm.middleEastDialog,
      callback: function callback($$v) {
        _vm.middleEastDialog = $$v;
      },
      expression: "middleEastDialog"
    }
  }, [_c('MiddleEast')], 1), _c('v-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$vuetify.breakpoint.lgAndUp,
      expression: "$vuetify.breakpoint.lgAndUp"
    }],
    attrs: {
      "top": "",
      "offset-y": "",
      "content-class": "map__menu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on,
            attrs = _ref3.attrs;
        return [_c('button', _vm._g(_vm._b({
          staticClass: "map__btn map__cis-nations",
          on: {
            "click": function click($event) {
              _vm.cisNationsDialog = true;
            },
            "mouseenter": function mouseenter($event) {
              _vm.cisNationsMenu = true;
            },
            "mouseleave": function mouseleave($event) {
              _vm.cisNationsMenu = false;
            }
          }
        }, 'button', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.cisNationsMenu,
      callback: function callback($$v) {
        _vm.cisNationsMenu = $$v;
      },
      expression: "cisNationsMenu"
    }
  }, [_c('div', {
    staticClass: "map__menu-inner",
    on: {
      "click": function click($event) {
        _vm.cisNationsDialog = true;
      }
    }
  }, [_vm._v(" 독립국가연합 ")])]), _c('button', {
    staticClass: "map__btn map__cis-nations d-lg-none",
    on: {
      "click": function click($event) {
        _vm.referenceCon();

        _vm.cisNationsCon = true;
      }
    }
  }), _c('u-dialog', {
    on: {
      "close": function close($event) {
        _vm.cisNationsDialog = false;
      }
    },
    model: {
      value: _vm.cisNationsDialog,
      callback: function callback($$v) {
        _vm.cisNationsDialog = $$v;
      },
      expression: "cisNationsDialog"
    }
  }, [_c('CisNations')], 1), _c('v-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$vuetify.breakpoint.lgAndUp,
      expression: "$vuetify.breakpoint.lgAndUp"
    }],
    attrs: {
      "top": "",
      "offset-y": "",
      "content-class": "map__menu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref4) {
        var on = _ref4.on,
            attrs = _ref4.attrs;
        return [_c('button', _vm._g(_vm._b({
          staticClass: "map__btn map__korea",
          on: {
            "click": function click($event) {
              _vm.koreaDialog = true;
            },
            "mouseenter": function mouseenter($event) {
              _vm.koreaMenu = true;
            },
            "mouseleave": function mouseleave($event) {
              _vm.koreaMenu = false;
            }
          }
        }, 'button', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.koreaMenu,
      callback: function callback($$v) {
        _vm.koreaMenu = $$v;
      },
      expression: "koreaMenu"
    }
  }, [_c('div', {
    staticClass: "map__menu-inner",
    on: {
      "click": function click($event) {
        _vm.koreaDialog = true;
      }
    }
  }, [_vm._v(" 대한민국 ")])]), _c('button', {
    staticClass: "map__btn map__korea d-lg-none",
    on: {
      "click": function click($event) {
        _vm.referenceCon();

        _vm.koreaCon = true;
      }
    }
  }), _c('u-dialog', {
    on: {
      "close": function close($event) {
        _vm.koreaDialog = false;
      }
    },
    model: {
      value: _vm.koreaDialog,
      callback: function callback($$v) {
        _vm.koreaDialog = $$v;
      },
      expression: "koreaDialog"
    }
  }, [_c('Korea')], 1), _c('v-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$vuetify.breakpoint.lgAndUp,
      expression: "$vuetify.breakpoint.lgAndUp"
    }],
    attrs: {
      "top": "",
      "offset-y": "",
      "content-class": "map__menu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref5) {
        var on = _ref5.on,
            attrs = _ref5.attrs;
        return [_c('button', _vm._g(_vm._b({
          staticClass: "map__btn map__asia",
          on: {
            "click": function click($event) {
              _vm.asiaDialog = true;
            },
            "mouseenter": function mouseenter($event) {
              _vm.asiaMenu = true;
            },
            "mouseleave": function mouseleave($event) {
              _vm.asiaMenu = false;
            }
          }
        }, 'button', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.asiaMenu,
      callback: function callback($$v) {
        _vm.asiaMenu = $$v;
      },
      expression: "asiaMenu"
    }
  }, [_c('div', {
    staticClass: "map__menu-inner",
    on: {
      "click": function click($event) {
        _vm.asiaDialog = true;
      }
    }
  }, [_vm._v(" 아시아 ")])]), _c('button', {
    staticClass: "map__btn map__asia d-lg-none",
    on: {
      "click": function click($event) {
        _vm.referenceCon();

        _vm.asiaCon = true;
      }
    }
  }), _c('u-dialog', {
    on: {
      "close": function close($event) {
        _vm.asiaDialog = false;
      }
    },
    model: {
      value: _vm.asiaDialog,
      callback: function callback($$v) {
        _vm.asiaDialog = $$v;
      },
      expression: "asiaDialog"
    }
  }, [_c('Asia')], 1)], 1), _c('div', {
    staticClass: "d-lg-none pt-60"
  }, [_c('America', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.americaCon,
      expression: "americaCon"
    }]
  }), _c('MiddleEast', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.middleEastCon,
      expression: "middleEastCon"
    }]
  }), _c('CisNations', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.cisNationsCon,
      expression: "cisNationsCon"
    }]
  }), _c('Korea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.koreaCon,
      expression: "koreaCon"
    }]
  }), _c('Asia', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.asiaCon,
      expression: "asiaCon"
    }]
  })], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }